export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function req<T>(
  path: string,
  opts: RequestInit = {},
): Promise<T> {
  const res = await fetch(`/api${path}`, {
    headers:
      opts.body && !(opts.body instanceof FormData)
        ? { "Content-Type": "application/json" }
        : undefined,
    ...opts,
  });
  const text = await res.text();
  let body: unknown = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      // Non-JSON body, usually an HTML 404 / proxy error from a stale or
      // not-running API server. Surface something actionable.
      const snippet = text.trim().replace(/\s+/g, " ").slice(0, 120);
      throw new ApiError(
        res.status,
        res.ok
          ? `Unexpected non-JSON response from ${path}`
          : `HTTP ${res.status} on ${path}${snippet ? `: ${snippet}` : ""}`,
      );
    }
  }
  if (!res.ok) {
    const msg = (body as { error?: string } | null)?.error;
    throw new ApiError(res.status, msg || res.statusText);
  }
  return body as T;
}

export const api = {
  get: <T>(p: string) => req<T>(p),
  post: <T>(p: string, body?: unknown) =>
    req<T>(p, { method: "POST", body: body ? JSON.stringify(body) : undefined }),
  put: <T>(p: string, body?: unknown) =>
    req<T>(p, { method: "PUT", body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(p: string, body?: unknown) =>
    req<T>(p, { method: "PATCH", body: body ? JSON.stringify(body) : undefined }),
  del: <T>(p: string, body?: unknown) =>
    req<T>(p, { method: "DELETE", body: body ? JSON.stringify(body) : undefined }),
  upload: <T>(p: string, form: FormData) =>
    req<T>(p, { method: "POST", body: form }),
};

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
